import { FilterProvider } from './context/FilterContext';
import Dashboard from './pages/Dashboard.jsx/Dashboard.jsx';

function App() {
  return (
    <FilterProvider>
      <Dashboard />
    </FilterProvider>
  );
}

export default App;
